import { render, staticRenderFns } from "./CirclesPercentage.vue?vue&type=template&id=3ebccc43&scoped=true&"
import script from "./CirclesPercentage.vue?vue&type=script&lang=ts&"
export * from "./CirclesPercentage.vue?vue&type=script&lang=ts&"
import style0 from "./CirclesPercentage.vue?vue&type=style&index=0&id=3ebccc43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebccc43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
